/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

/**
 * @param {boolean} targetingEnabled - enable or disable targeting in query
 */
const findProductsBySearchTerm = (targetingEnabled, experiments) => (
    // very important for serializing. add space between bracket and query name + add typenames to query
    gql`
    query SearchProductQuery($brand: String!, $productOptions: ProductOptions, $environment: String!, $term: String!${targetingEnabled ? ', $targeting: [Targeting]' : ''}) {
        findProductsBySearchTerm(brand: $brand, environment: $environment, term: $term, productOptions: $productOptions${targetingEnabled ? ', targeting: $targeting' : ''}) {
            redirectUrl
            productFacets{
                name
                value
                type
                displayOpen
                entries{
                    name
                    value
                    from
                    to
                    count
                }
            }
            products {
                id
                productSkus {
                    id
                }
                brandId
                reviews
                image {
                    altText
                    name
                    path
                    snipe
                    snipeProductEndDate
                    snipeCategoryEndDate
                    snipeProductStartDate
                    snipeCategoryStartDate
                }
                partNumber
                baseCode
                prices {
                    currency
                    type
                    value
                    __typename
                }
                skuPriceRange {
                    sale {
                        value
                    }
                    retail {
                        value
                    }
                }
                name
                brand
                seo {
                    url
                }
                productType
                availability {
                    availabilityIndicator
                    deliveryDateType
                    displayEndDate
                    displayStartDate
                    earliestShipDate
                    latestShipDate
                    perishable
                    productDeliveryType
                    shipAlone
                    deliveryMessage
                }
            }
            totalPages
            totalProducts
            originalQuery
            canShowResultsFor
            showingResultsFor
            ${experiments ? 'experiments' : ''}
            attributionToken
        }
    }
`
);

export default findProductsBySearchTerm;
